import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgDash = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33334 8.00001C5.33334 7.70546 5.57213 7.46667 5.86668 7.46667H10.1333C10.4279 7.46667 10.6667 7.70546 10.6667 8.00001C10.6667 8.29456 10.4279 8.53334 10.1333 8.53334H5.86668C5.57213 8.53334 5.33334 8.29456 5.33334 8.00001Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDash)
const IconSvgDash = createIcon(ForwardRef, 'SvgDash')
export default IconSvgDash
